<div class="flex w-full max-w-full flex-col items-center gap-4 overflow-hidden xl:flex-row xl:justify-between xl:gap-0">
    <div class="max-w-full px-3 sm:px-0 xl:max-w-40 xl:min-w-40">
        <span class="text-title-medium text-left">{{ inputResultsLength() | displayResults }}</span>
    </div>

    <div
        class="flex w-full max-w-full flex-col items-center justify-end gap-3 overflow-hidden px-3 sm:px-0 lg:gap-9 xl:flex-row"
    >
        <div class="flex w-full max-w-full items-center justify-end gap-2 overflow-hidden">
            <div
                class="border-neutral-variant-40/20 focus-within:border-neutral-variant flex w-full max-w-full flex-col gap-2 overflow-hidden rounded-lg border px-3.5 py-2 xl:h-12 xl:w-fit xl:flex-row xl:items-center xl:py-0"
            >
                <div class="flex w-full items-center justify-between gap-4 xl:flex-1">
                    <label for="supplier-search" class="sr-only">
                        {{ "supplier_search.search_placeholder" | transloco }}
                    </label>
                    <input
                        id="supplier-search"
                        class="text-secondary w-full max-w-58 opacity-60 outline-none xl:min-w-40"
                        placeholder="{{ 'supplier_search.search_placeholder' | transloco }}"
                        type="text"
                        [(ngModel)]="searchValue"
                    />
                    <button
                        class="bg-primary hover:bg-primary/80 cursor-pointer rounded-full p-2 text-white xl:hidden"
                        type="button"
                        (click)="search()"
                        [attr.aria-label]="'supplier_search.search' | transloco"
                    >
                        <svg-icon src="assets/icons/Search.svg" [svgStyle]="{ width: '16px', height: '16px' }" />
                    </button>
                </div>

                @if (inputSearchType() === "supplier") {
                    <span
                        class="border-neutral-variant-40/20 w-full border-t xl:h-8 xl:w-auto xl:border-t-0 xl:border-r"
                    ></span>

                    <div class="flex w-full items-center justify-between gap-4 xl:gap-4">
                        <div class="flex items-center gap-2 opacity-60">
                            <svg-icon
                                src="assets/icons/Compass-Arrow.svg"
                                [svgStyle]="{ width: '16px', height: '16px' }"
                            />
                            <label for="postal-code" class="sr-only">
                                {{ "supplier_search.postal_code_placeholder" | transloco }}
                            </label>
                            <input
                                id="postal-code"
                                class="text-secondary w-24 outline-none"
                                placeholder="{{ 'supplier_search.postal_code_placeholder' | transloco }}"
                                type="text"
                                mask="A0A 0A0|00000"
                                [dropSpecialCharacters]="false"
                                [validation]="true"
                                [(ngModel)]="postalCode"
                            />
                        </div>

                        <el-select class="relative inline-block lg:max-w-35 lg:min-w-35" [value]="distance()?.value">
                            <button
                                type="button"
                                (click)="isDistanceOpen.set(!isDistanceOpen())"
                                class="hover:bg-primary/10 flex w-full cursor-pointer items-center justify-between gap-2 rounded-lg px-3.5 py-2 text-left opacity-60"
                            >
                                <svg-icon
                                    src="assets/icons/Trip-Destination.svg"
                                    [svgStyle]="{ width: '16px', height: '16px' }"
                                />
                                <el-selectedcontent class="text-secondary">
                                    @if (distance(); as distance) {
                                        {{ distance.label }}
                                    } @else {
                                        {{ "supplier_search.distance_placeholder" | transloco }}
                                    }
                                </el-selectedcontent>
                                <svg-icon
                                    [src]="'assets/icons/' + (isDistanceOpen() ? 'Arrow-Up-1.svg' : 'Arrow-Down-1.svg')"
                                    [svgStyle]="{ width: '16px', height: '16px' }"
                                />
                            </button>

                            <el-options
                                anchor="bottom start"
                                popover
                                class="max-h-60 w-56 overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline outline-black/5 transition-discrete data-leave:transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm"
                            >
                                @for (distance of distances; track distance.value) {
                                    <el-option
                                        [value]="distance.value"
                                        class="aria-selected:bg-primary hover:bg-primary/10 block cursor-pointer truncate px-3 py-2 select-none aria-selected:text-white"
                                        (click)="selectDistance(distance)"
                                    >
                                        {{ distance.label }}
                                    </el-option>
                                }
                            </el-options>
                        </el-select>
                    </div>

                    <span
                        class="border-neutral-variant-40/20 w-full border-t xl:h-8 xl:w-auto xl:border-t-0 xl:border-r"
                    ></span>

                    <el-select class="relative inline-block w-full xl:max-w-43 xl:min-w-43">
                        <button
                            type="button"
                            (click)="isCertificationsOpen.set(!isCertificationsOpen())"
                            class="hover:bg-primary/10 flex w-full cursor-pointer items-center justify-between gap-2 rounded-lg py-2 pr-3.5 text-left opacity-60 xl:px-3.5"
                        >
                            <div class="flex items-center gap-2 truncate">
                                <svg-icon
                                    src="assets/icons/Certified-Ribbon-1.svg"
                                    [svgStyle]="{ width: '16px', height: '16px' }"
                                />
                                <el-selectedcontent class="text-secondary truncate">
                                    @if (selectedCertificationsIds().length === 0) {
                                        {{ "supplier_search.certifications_placeholder" | transloco }}
                                    } @else if (selectedCertificationsIds().length === 1) {
                                        {{ selectedCertificationName() }}
                                    } @else {
                                        {{ selectedCertificationsIds().length }}
                                        {{ "supplier_search.certifications_multiple" | transloco }}
                                    }
                                </el-selectedcontent>
                            </div>
                            <svg-icon
                                [src]="
                                    'assets/icons/' + (isCertificationsOpen() ? 'Arrow-Up-1.svg' : 'Arrow-Down-1.svg')
                                "
                                [svgStyle]="{ width: '16px', height: '16px' }"
                            />
                        </button>

                        <el-options
                            anchor="bottom start"
                            popover
                            class="max-h-60 w-64 overflow-auto rounded-md bg-white py-2 text-base shadow-lg outline outline-black/5 transition-discrete data-leave:transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm"
                        >
                            @for (certification of inputItemsCertifications(); track certification.id) {
                                <div
                                    class="hover:bg-primary/10 focus:bg-primary/10 flex cursor-pointer items-center gap-3 px-3 py-2 focus:outline-none"
                                    tabindex="0"
                                    role="option"
                                    [attr.aria-selected]="selectedCertificationsIds() | includes: certification.id!"
                                    (click)="toggleCertification(certification.id!)"
                                    (keydown.enter)="toggleCertification(certification.id!)"
                                    (keydown.space)="toggleCertification(certification.id!); $event.preventDefault()"
                                >
                                    <div class="flex h-5 shrink-0 items-center">
                                        <div class="group grid size-4 grid-cols-1">
                                            <input
                                                type="checkbox"
                                                [checked]="selectedCertificationsIds() | includes: certification.id!"
                                                class="checked:border-primary checked:bg-primary focus-visible:outline-primary pointer-events-none col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white focus-visible:outline-2 focus-visible:outline-offset-2 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100"
                                            />
                                            <svg
                                                viewBox="0 0 14 14"
                                                fill="none"
                                                class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25"
                                            >
                                                <path
                                                    d="M3 8L6 11L11 3.5"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    class="opacity-0 group-has-checked:opacity-100"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <img
                                        [ngSrc]="certification?.logo | getDirectusImage"
                                        [alt]="certification.name"
                                        width="150"
                                        height="150"
                                        class="size-10 object-contain"
                                    />
                                    <span class="text-sm text-gray-700">
                                        {{ certification.name }}
                                    </span>
                                </div>
                            }
                        </el-options>
                    </el-select>
                }

                <button
                    class="bg-primary hover:bg-primary/80 hidden cursor-pointer rounded-full p-2 text-white xl:block"
                    type="button"
                    (click)="search()"
                    [attr.aria-label]="'supplier_search.search' | transloco"
                >
                    <svg-icon src="assets/icons/Search.svg" [svgStyle]="{ width: '16px', height: '16px' }" />
                </button>
            </div>

            <el-select
                class="relative block size-12 lg:hidden"
                [class.hidden]="inputSearchType() === 'supplier' || hideSubcategory()"
            >
                <button
                    type="button"
                    class="border-primary hover:bg-primary/10 mt-auto size-12 cursor-pointer rounded-lg border p-3 text-left"
                >
                    <svg-icon
                        class="text-primary"
                        src="assets/icons/Filter-Sort-Lines-Descending.svg"
                        [svgStyle]="{ width: '24px', height: '24px' }"
                    />
                </button>

                <el-options
                    anchor="bottom start"
                    popover
                    class="max-h-60 w-56 overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline outline-black/5 transition-discrete data-leave:transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm"
                >
                    <el-option
                        class="aria-selected:bg-primary hover:bg-primary/10 block cursor-pointer truncate px-3 py-2 select-none aria-selected:text-white"
                        (click)="resetSelectedSubcategoryId()"
                    >
                        {{ "subcategory_sidebar.subcategories" | transloco }}
                    </el-option>
                    @for (subcategory of subcategories(); track subcategory.id) {
                        <el-option
                            [value]="subcategory.id"
                            class="aria-selected:bg-primary hover:bg-primary/10 block cursor-pointer truncate px-3 py-2 select-none aria-selected:text-white"
                            (click)="setSuppliersBySubcategory(subcategory.id)"
                        >
                            {{ subcategory.translations_refs | getTranslation: "title" }}
                        </el-option>
                    }
                </el-options>
            </el-select>
        </div>

        <div
            class="flex w-full justify-between gap-2 xl:w-fit xl:min-w-60"
            [class.hidden]="inputSearchType() === 'subcategory'"
        >
            <div class="relative w-full">
                <div class="bg-custom-2 peer flex items-center justify-between gap-3 rounded-lg px-4 py-3">
                    <div class="flex items-center gap-3">
                        <svg-icon src="assets/icons/Eco-Friendly.svg" [svgStyle]="{ width: '20px', height: '20px' }" />
                        <span class="text-body-small text-white">{{
                            "supplier_search.eco_responsible" | transloco
                        }}</span>
                    </div>
                    <div
                        class="group bg-custom-2-95 has-checked:bg-custom-2-95 relative inline-flex w-11 shrink-0 cursor-pointer rounded-full p-0.5 transition-colors duration-200 ease-in-out has-focus-visible:outline-2"
                    >
                        <span
                            class="bg-custom-2-40/60 group-has-checked:bg-custom-2-40 size-5 cursor-pointer rounded-full transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"
                        ></span>
                        <input
                            type="checkbox"
                            [checked]="isEcoFriendly()"
                            class="absolute inset-0 cursor-pointer appearance-none focus:outline-hidden"
                            [(ngModel)]="isEcoFriendly"
                            [attr.aria-label]="'supplier_search.eco_responsible' | transloco"
                            id="eco-friendly-toggle"
                        />
                        <label for="eco-friendly-toggle" class="sr-only">{{
                            "supplier_search.eco_responsible" | transloco
                        }}</label>
                    </div>
                </div>
                <div
                    class="bg-custom-2 pointer-events-none absolute left-1/2 z-50 mt-2 w-[calc(100vw-2rem)] max-w-40 min-w-0 -translate-x-1/2 transform rounded px-3 py-1 text-sm break-words text-white opacity-0 transition-opacity duration-200 peer-hover:opacity-100 sm:w-auto sm:min-w-40"
                >
                    <span class="break-words text-white sm:break-normal">
                        {{ "supplier_search.eco_responsible_tooltip" | transloco }}
                    </span>
                </div>
            </div>

            <el-select class="relative block size-12 lg:hidden" [class.hidden]="hideSubcategory()">
                <button
                    type="button"
                    class="border-primary hover:bg-primary/10 mt-auto size-12 cursor-pointer rounded-lg border p-3 text-left"
                >
                    <div class="bg-primary absolute top-2 left-9 size-1.5 rounded-full"></div>
                    <svg-icon
                        class="text-primary"
                        src="assets/icons/Filter-Sort-Lines-Descending.svg"
                        [svgStyle]="{ width: '24px', height: '24px' }"
                    />
                </button>

                <el-options
                    anchor="bottom start"
                    popover
                    class="max-h-60 w-56 overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline outline-black/5 transition-discrete data-leave:transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm"
                >
                    <el-option
                        class="aria-selected:bg-primary hover:bg-primary/10 block cursor-pointer truncate px-3 py-2 select-none aria-selected:text-white"
                        (click)="resetSelectedSubcategoryId()"
                    >
                        {{ "subcategory_sidebar.all_subcategories" | transloco }}
                    </el-option>
                    @for (subcategory of subcategories(); track subcategory.id) {
                        <el-option
                            [value]="subcategory.id"
                            class="aria-selected:bg-primary hover:bg-primary/10 block cursor-pointer truncate px-3 py-2 select-none aria-selected:text-white"
                            (click)="setSuppliersBySubcategory(subcategory.id)"
                        >
                            {{ subcategory.translations_refs | getTranslation: "title" }}
                        </el-option>
                    }
                </el-options>
            </el-select>
        </div>
    </div>
</div>
